import React from 'react';
import { Tool, Warehouse, AssignmentLogEntry, Users, ToolHistory, Classes } from '../../types';
import ToolCard from './ToolCard';
import { match } from 'assert';


interface ToolGridProps {
  tools: Tool[];
  warehouses: Warehouse[];
  people: Users[];
  history: ToolHistory[];
  classes: Classes[];
  assignmentLogs: AssignmentLogEntry[];
  selectedToolIds: number[];
  onToggleToolSelect: (toolId: number) => void;
  searchTerm: string;
  selectedWarehouseId: number | null;
}

const ToolGrid: React.FC<ToolGridProps> = ({ 
  tools, 
  warehouses,
  people,
  history,
  classes,
  assignmentLogs,
  selectedToolIds, 
  onToggleToolSelect, 
  searchTerm, 
  selectedWarehouseId 
}) => {
  const filteredTools = tools.filter(tool => {
    
    const searchtext = searchTerm.toLowerCase().split(' ');
    const result:boolean = searchtext.map( text =>{
      const toolwh = warehouses.find(w => w.id === tool.warehouse)!.name.toLowerCase().includes(text);
      
      const matchestxt = (tool.txt!==null)?tool.txt!.toLowerCase().includes(text):false;
      const matchesnote = (tool.note!==null)?tool.note!.toLowerCase().includes(text):false;
      const filterwh = (selectedWarehouseId!==null)?tool.warehouse===selectedWarehouseId:true;
      
      const matchclass = tool.classify.some(c => classes.find(cl => cl.id === c)?.txt?.toLowerCase()?.includes(text));
      
      const hfind = history.find(h => h.toolid === tool.id)?.userid;
      const matchuser = people.find(u => u.id === hfind)?.name.toLowerCase().includes(text);
      
      
      //console.log(matchuser);
      return filterwh&&(toolwh||matchestxt||matchesnote||matchclass||matchuser?true:false);

    }).reduce((acc, next)=> acc||next , false );
    
    //&& !tool.currentAssignmentLogId : !tool.currentAssignmentLogId
    //const matchesWarehouse = selectedWarehouseId ? tool.warehouse === selectedWarehouseId : false;
    //const matchesSearch = true;
    //                      || tool.note!==null?tool.note!.toLowerCase().includes(searchtext):false 
    //                      || toolwh;
    return result;
  });

  //tool.currentAssignmentLogId
  /*const assignedTools = tools.filter(tool => true && 
    (selectedWarehouseId ? false : true) && true // only show assigned tools if "All Warehouses" is selected or for specific search.
  );*/
  
  //(tool.txt!.toLowerCase().includes(searchTerm.toLowerCase()) || tool.note?tool.note!.toLowerCase().includes(searchTerm.toLowerCase()):false)
  //const displayedTools = selectedWarehouseId ? filteredTools : [...filteredTools, ...assignedTools].sort((a,b) => a.txt!.localeCompare(b.txt!));

  const displayedTools = [...filteredTools].sort((a,b) => a.txt!.localeCompare(b.txt!));

  if (displayedTools.length === 0 && searchTerm) {
    return <p className="text-center text-slate-400 py-10">Nessun attrezzo trovato per "{searchTerm}" {selectedWarehouseId ? `in ${warehouses.find(w => w.id === selectedWarehouseId)?.name}` : ''}.</p>;
  }
  
  /*if (displayedTools.length === 0 && selectedWarehouseId) {
    return <p className="text-center text-slate-400 py-10">Nessun attrezzo disponibile in {warehouses.find(w => w.id === selectedWarehouseId)?.name}.</p>;
  }*/


  return (
    <div className="h-full max-h-3/4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 p-4">
      {displayedTools.map(tool => {
        //const assignmentLog = tool.currentAssignmentLogId ? assignmentLogs.find(log => log.id === tool.currentAssignmentLogId) : null;
        //const assignee = assignmentLog ? people.find(p => p.id === assignmentLog.assigneeId) : null;
        //const warehouse = tool.warehouseId ? warehouses.find(w => w.id === tool.warehouseId) : null;
        const assigneddate = history.find(h => h.toolid === tool.id)?history.find(h => h.toolid === tool.id)?.assigned:null;
        const assignee = history.find(h => h.toolid === tool.id)?people.find(p=>p.id===history.find(h => h.toolid === tool.id)?.userid):null;
        const warehouse = tools.find(t => t.id === tool.id)?warehouses.find(w => w.id === tools.find(t => t.id === tool.id)?.warehouse):null;
        const clastxt = tool.classify.map(c=>classes.find(cl=>cl.id===c)?.txt)?.join(', ');
        return (
          <ToolCard
            key={tool.id}
            tool={tool}
            isSelected={selectedToolIds.includes(tool.id!)}
            onToggleSelect={onToggleToolSelect}
            assignmentDate={assigneddate}
            history={history}
            assignee={assignee}
            warehouse={warehouse}
            classes={clastxt}
          />
        );
      })}
    </div>
  );
};

export default ToolGrid;
